import { Pipe, PipeTransform } from '@angular/core';
import { textToHtml } from '../utils/html-text';

/**
 * Inserts <wbr> after "@", ".", "/" and "-" so emails and URLs wrap at sensible boundaries. It adds
 * no glyph and is not copied. The value is HTML-escaped first, so only our own tags are live, and
 * Angular's own [innerHTML] sanitizer still runs over the result.
 */
@Pipe({
  name: 'softBreak'
})
export class SoftBreakPipe implements PipeTransform {

  transform(value?: string | null): string {
    if (!value) {
      return '';
    }
    const escaped = textToHtml(value)
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
    // Add a break opportunity after @ . / and - so wrapping happens between
    // the email/URL segments rather than in the middle of one.
    return escaped.replace(/([@.\/-])/g, '$1<wbr>');
  }

}
